import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import UploadXML from "./pages/UploadXML";
import Conference from "./pages/Conference";
import Audit from "./pages/Audit";
import Reports from "./pages/Reports";
import UsersPage from "./pages/Users";
import SettingsPage from "./pages/Settings";
import SuperAdmin from "./pages/SuperAdmin";

// Protected Route Component
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1a365d]"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

// Public Route (redirects to dashboard if logged in)
const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1a365d]"></div>
      </div>
    );
  }

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* SuperAdmin Route - Acesso exclusivo por senha */}
      <Route path="/super-admin" element={<SuperAdmin />} />

      {/* Public Routes */}
      <Route 
        path="/login" 
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        } 
      />

      {/* Protected Routes - All Users */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/upload" 
        element={
          <ProtectedRoute>
            <UploadXML />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/conference" 
        element={
          <ProtectedRoute>
            <Conference />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings" 
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        } 
      />

      {/* Protected Routes - Gestor and Admin */}
      <Route 
        path="/audit" 
        element={
          <ProtectedRoute allowedRoles={["admin_master", "gestor"]}>
            <Audit />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/reports" 
        element={
          <ProtectedRoute allowedRoles={["admin_master", "gestor"]}>
            <Reports />
          </ProtectedRoute>
        } 
      />

      {/* Protected Routes - Users Management */}
      <Route 
        path="/users" 
        element={
          <ProtectedRoute allowedRoles={["admin_master", "gestor", "operador"]}>
            <UsersPage />
          </ProtectedRoute>
        } 
      />

      {/* Rota de Companies removida - gestão de empresas será feita em painel externo */}

      {/* Default Redirect */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
